import axios from "axios";
import resource from "./img/resource.png";
import join0 from "./img/0.png";
import join1 from "./img/1.png";
import join2 from "./img/2.png";
import join3 from "./img/3.png";
import join4 from "./img/4.png";
export interface getReportProps {
    batchNo: string;
    courseNo: string;
    courseSeq: string;
    customerCode: string;
}
interface getReportDataProps {
    paperAvg: string; //作业平均分 百分制
    paperJoin: string; //作业参与数
    paper: string; //发布作业数
    votePaperJoin: string; //投票参与数
    votePaper: string; //投票数
    votePaperParticipation: string; //投票百分比
    exerciseJoin: string; //练习参与数
    exerciseAvg: string; //练习平均得分
    exercise: string; //练习个数
    groupTask: string; //小组任务数
    groupTaskJoin: string; //小组参与次数
    groupTaskParticipation: string; //小组任务参与率
    groupTaskAvg: string; //小组任务平均得分
    signIn: string; //发布签到数
    signInLeave: string; //请假
    signInNormal: string; //正常出勤数
    signInLate: string; //迟到数
    signInEarly: string; //早退数
    courseware: string; //课件数
    coursewareJoin: string; //课件完成数
    coursewareParticipation: string; //课程资源学习完成
}
function getObj(
    img: string,
    title: string,
    item: [string, string, string][],
    other?: [string, string, string],
    help?: string
) {
    return {
        img,
        help,
        title,
        item: item.map(i => i.join("")),
        other: other?.join(",") || ""
    };
}
export function getReportData(params: getReportProps) {
    return axios
        .get<SuccessData<getReportDataProps>>(
            `/student/getStudentStudyReport`,
            {
                params
            }
        )
        .then(res => res.data.data)
        .then(res => {
            return {
                response: res,
                CoursewareLearning: [
                    getObj(
                        resource,
                        "课件学习",
                        [
                            [
                                "已学习课件：",
                                `${res.coursewareJoin} / ${res.courseware}`,
                                ""
                            ]
                        ],
                        ["完成率", res.coursewareParticipation, ""]
                    )
                ],
                Join: [
                    getObj(
                        join3,
                        "作业",
                        [
                            [
                                "已参与作业：",
                                `${res.paperJoin} / ${res.paper}`,
                                ""
                            ]
                        ],
                        ["平均得分", res.paperAvg, ""]
                    ),
                    getObj(
                        join2,
                        "练习",
                        [
                            [
                                "已参与练习：",
                                `${res.exerciseJoin} / ${res.exercise}`,
                                ""
                            ]
                        ],
                        ["平均得分", res.exerciseAvg, ""]
                    ),
                    getObj(
                        join4,
                        "小组活动",
                        [
                            [
                                "已参与活动：",
                                `${res.groupTaskJoin} / ${res.groupTask}`,
                                ""
                            ]
                        ],
                        ["平均得分", res.groupTaskAvg, ""]
                    ),
                    getObj(
                        join1,
                        "投票",
                        [
                            [
                                "已参与投票：",
                                `${res.votePaperJoin} / ${res.votePaper}`,
                                ""
                            ]
                        ],
                        ["参与率", res.votePaperParticipation, ""]
                    ),
                    getObj(join0, "签到", [
                        ["发起签到：", res.signIn, "次"],
                        ["正常出勤：", res.signInNormal, "次"],
                        ["迟到：", res.signInLate, "次"],
                        ["早退：", res.signInEarly, "次"],
                        ["请假：", res.signInLeave, "次"]
                    ])
                ]
            };
        });
}
